import { render, staticRenderFns } from "./InputCatalogLink.vue?vue&type=template&id=49e49151"
import script from "./InputCatalogLink.vue?vue&type=script&lang=ts"
export * from "./InputCatalogLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports